import React, { useContext } from 'react';
import get from 'lodash/get';

import Checkbox from 'src/presentation/components/forms/Checkbox';
import FormContext from 'src/presentation/contexts/FormContext';
import Input from 'src/presentation/components/forms/Input';
import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';

import {
  CustomRow,
  DefaultSection,
  HeaderPosition,
  MediumHeader,
  PrimaryDescription,
} from 'src/presentation/components/pages/chat/ChatLayout';
import { FIELDS_MAPPER } from '../chatConstants';

const GoogleAnalyticsSection = () => {
  const { workingState } = useContext(FormContext);
  const isFeatureEnabled = useIsFeatureEnabled();
  const isSalesAttributionEnabled = isFeatureEnabled('salesAttributionEnablement');

  if (!isSalesAttributionEnabled) {
    return null;
  }

  const gaEnabled = get(workingState, FIELDS_MAPPER.GA_ENABLED.path, false);
  const autoDetectEnabled = get(workingState, FIELDS_MAPPER.GA_AUTO_DETECT_TRACKING_ID.path, false);

  return (
    <>
      <MediumHeader>Google Analytics Configuration</MediumHeader>
      <PrimaryDescription>
        Enable Google Analytics tracking for sales attribution in chat. Track customer interactions and conversions to
        measure chat effectiveness.
      </PrimaryDescription>
      <DefaultSection headerPosition={HeaderPosition.OUTSIDE_BLOCK}>
        <CustomRow>
          <Checkbox
            attr={FIELDS_MAPPER.GA_ENABLED.path}
            data-aid={FIELDS_MAPPER.GA_ENABLED.path}
            label="Enable Google Analytics Tracking"
            description={FIELDS_MAPPER.GA_ENABLED.description}
          />
        </CustomRow>

        {gaEnabled && (
          <>
            <CustomRow>
              <Checkbox
                attr={FIELDS_MAPPER.GA_AUTO_DETECT_TRACKING_ID.path}
                data-aid={FIELDS_MAPPER.GA_AUTO_DETECT_TRACKING_ID.path}
                label="Auto-detect Tracking ID (Recommended)"
                description={FIELDS_MAPPER.GA_AUTO_DETECT_TRACKING_ID.description}
              />
            </CustomRow>

            {!autoDetectEnabled && (
              <CustomRow>
                <Input
                  attr={FIELDS_MAPPER.GA_TRACKING_ID.path}
                  data-aid={FIELDS_MAPPER.GA_TRACKING_ID.path}
                  label="Custom GA4 Tracking ID"
                  description={FIELDS_MAPPER.GA_TRACKING_ID.description}
                  placeholder="G-XXXXXXXXXX"
                />
              </CustomRow>
            )}
          </>
        )}
      </DefaultSection>
    </>
  );
};

export default GoogleAnalyticsSection;
